import { GamifiedQuizFooterProps } from "../types/GamifiedQuiz.type";

const GamifiedQuizFooter: React.FC<GamifiedQuizFooterProps> = ({
  footerText,
  footerLink,
  themeManager,
}) => {
  return (
    <div
      className="gamified-quiz-footer-section"
      style={themeManager.getGamifiedQuizFooterStyles()}
    >
      <div
        className="footer-content"
        onClick={() =>
          window.open(
            footerLink ? footerLink : "https://www.plgos.com/",
            "_blank"
          )
        }
        style={themeManager.getGamifiedQuizFooterStyles()}
      >
        {footerText || "Powered by PLG OS"}
      </div>
    </div>
  );
};

export default GamifiedQuizFooter;
